import { ref, watch, computed } from '@vue/composition-api';
import { TABLE } from '@/constants/config';
import { pluck } from '@/helpers';

export default function usePendingDirectorsTable() {
    const refPendingDirectorListTable = ref(null);
    const pendingDirectors = ref(null);

    // Table Handlers
    const pendingDirectorTableColumns = [
        { key: 'index', label: '#', thClass: 'px-1 pr-2', tdClass: 'px-1 pr-2' },
        { key: 'nric', label: 'ID', sortable: true, thClass: 'px-0 pr-2', tdClass: 'px-0 pr-2' },
        { key: 'name', label: 'NAME', sortable: true, thClass: 'px-0 pr-2', tdClass: 'px-0 pr-2' },
        { key: 'email', label: 'EMAIL', sortable: true, thClass: 'px-0 pr-2', tdClass: 'px-0 pr-2 text-break' },
        { key: 'appointmentDate', label: 'APPOINTMENT', sortable: true, thClass: 'px-0 pr-2', tdClass: 'px-0 pr-2' },
        { key: 'cessationDate', label: 'CESSATION', sortable: true, thClass: 'px-0 pr-2', tdClass: 'px-0 pr-2' },
        { key: 'actions', label: 'ACTION', thClass: 'pl-0 pr-1 text-right', tdClass: 'px-0 pr-1 text-right' },
    ];

    const pendingDirectorPerPage = ref(TABLE.PER_PAGE);
    const totalPendingDirectors = ref(0);
    const pendingDirectorCurrentPage = ref(1);
    const pendingDirectorPerPageOptions = TABLE.PER_PAGE_OPTIONS;
    const pendingDirectorSearchQuery = ref('');
    const sortPendingDirectorBy = ref('id');
    const isSortDirDescPendingDirector = ref(true);
    const isPendingDirectorBusy = ref(false);

    // local variable to store the companies list
    const isLoadingPendingDirector = ref(false);

    // options where the search query is applied
    // make sure to list as keys of how to access those values in table 
    const filterOnPendingDirector = ref([
        'nric',
        'name',
        'email',
    ]);

    const PendingDirectorDataMeta = computed(() => {
        const localItemsCount = refPendingDirectorListTable.value ? refPendingDirectorListTable.value.localItems.length : 0;
        totalPendingDirectors.value = localItemsCount;
        return {
            from: pendingDirectorPerPage.value * (pendingDirectorCurrentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: pendingDirectorPerPage.value * (pendingDirectorCurrentPage.value - 1) + localItemsCount,
            of: totalPendingDirectors.value,
        };
    });

    const refetchPendingDirectorData = () => {
        refPendingDirectorListTable.value.refresh();
    };

    watch([pendingDirectorCurrentPage, pendingDirectorPerPage, pendingDirectorSearchQuery], () => {
        refetchPendingDirectorData();
        const data = refPendingDirectorListTable.value.localItems;
        const queryLowered = pendingDirectorSearchQuery.value.toLowerCase().trim();

        //  if a query present then search
        if (queryLowered)
        {
            refPendingDirectorListTable.value.localItems = data.filter(item => filterOnPendingDirector.value.some(key => {
                const value = pluck(key, item);
                return value && value.toString().toLowerCase().trim().includes(queryLowered);
            }));
        }

        isPendingDirectorBusy.value = false;
    });

    return {
        sortPendingDirectorBy,
        isPendingDirectorBusy,
        pendingDirectorPerPage,
        PendingDirectorDataMeta,
        isLoadingPendingDirector,
        pendingDirectorSearchQuery,
        pendingDirectorCurrentPage,
        pendingDirectorTableColumns,
        isSortDirDescPendingDirector,
        totalPendingDirectors,
        pendingDirectorPerPageOptions,
        refPendingDirectorListTable,

        pendingDirectors,
        refetchPendingDirectorData,
        filterOnPendingDirector,
    };
}
